// utils/authEvents.js
class AuthEventBus {
    constructor() {
        this.listeners = new Map();
    }

    subscribe(event, callback) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event).add(callback);
        
        // Return unsubscribe function
        return () => {
            this.listeners.get(event)?.delete(callback);
        };
    }

    emit(event, data) {
        //console.log(`📤 Evento emesso: ${event}`, data);
        this.listeners.get(event)?.forEach(callback => {
            try {
                callback(data);
            } catch (err) {
                console.error(`Errore in listener per ${event}:`, err);
            }
        });
    }
}

// Singolo istanza globale
export const authEventBus = new AuthEventBus();

// Eventi disponibili
export const AUTH_EVENTS = {
    USER_UPDATED: 'user:updated',
    LOGIN: 'user:login',
    LOGOUT: 'user:logout',
    AUTH_CHANGED: 'auth:changed',
    PROFILE_UPDATED: 'profile:updated'
};
